module.exports = __webpack_public_path__ + "img/logo.e0d4f97c.png";